import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler } from 'utils';

import discoverReviewApi from 'api/discoverReview';
import {
  DELETE_DISCOVERY_REVIEW,
  GET_DISCOVERY_REVIEWS,
  GET_DISCOVERY_REVIEW_DETAILS,
} from './actionTypes';
import {
  actionDeleteDiscoveryReviewFailed,
  actionDeleteDiscoveryReviewSuccess,
  actionGetDiscoveryReviewDetailsFailed,
  actionGetDiscoveryReviewDetailsSuccess,
  actionGetDiscoveryReviewsFailed,
  actionGetDiscoveryReviewsSuccess,
} from './actions';

function* getDiscoveryReviews({ payload }) {
  try {
    const r = yield discoverReviewApi.getDiscoverReviews(payload);
    yield put(actionGetDiscoveryReviewsSuccess(r.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetDiscoveryReviewsFailed());
  }
}

function* getDiscoveryReviewDetails({ payload }) {
  try {
    const r = yield discoverReviewApi.getDiscoverReviewDetails(payload);
    yield put(actionGetDiscoveryReviewDetailsSuccess(r.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetDiscoveryReviewDetailsFailed());
  }
}

function* deleteDiscoveryReview({ payload }) {
  try {
    yield discoverReviewApi.deleteDiscoverReview(payload.id);
    payload.callback();
    yield put(actionDeleteDiscoveryReviewSuccess(payload.id));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionDeleteDiscoveryReviewFailed());
  }
}

export default function* discoverReview() {
  yield takeLeading(GET_DISCOVERY_REVIEWS, getDiscoveryReviews);
  yield takeLeading(GET_DISCOVERY_REVIEW_DETAILS, getDiscoveryReviewDetails);
  yield takeLeading(DELETE_DISCOVERY_REVIEW, deleteDiscoveryReview);
}
